/**
 * detailTab.ts — Tab-Normalisierung für die Hotspot-Detail-Seite.
 *
 * Eigene Datei (statt Export aus HotspotDetail.tsx), damit die Komponenten-
 * Datei nur Komponenten exportiert (react-refresh/only-export-components).
 *
 * Default ist "Rewards & Aktivität" (heliumtracker-web#24: "Data Transfer"
 * als Default ergab fuer ein IoT-Geraet keinen Sinn — Hosts interessieren
 * sich beim Oeffnen zuerst fuer Ertraege/Splits, nicht fuer Rohdaten-Traffic).
 * Die Legacy-Suchparameter 'performance'/'speedtests' (W1.3) landen ebenfalls
 * im Tab „Rewards & Aktivität", wo die entsprechenden Sections weiterleben.
 */
export type DetailTab = 'transfer' | 'rewards' | 'splits' | 'guard' | 'poc' | 'notes'

/**
 * Issue web#97: Tabs mit besitzerabhaengigem Inhalt (Splits/Provisionen,
 * Guard-Schalter, Notizen+Tags) — fuer fremde Hotspots ausgeblendet.
 */
export const OWNER_ONLY_TABS: readonly DetailTab[] = ['splits', 'guard', 'notes']

export function normalizeDetailTab(tab?: string): DetailTab {
  // W3-Gegentest BUG 1: "poc-archive" ist ein gültiger Deep-Link-Alias
  // (alte geteilte Links) und landet im Tab „PoC-Archiv".
  if (tab === 'poc' || tab === 'poc-archive') return 'poc'
  if (tab === 'transfer') return 'transfer'
  if (tab === 'splits') return 'splits'
  if (tab === 'guard') return 'guard'
  if (tab === 'notes') return 'notes'
  return 'rewards'
}
